module.exports = __webpack_public_path__ + "media/images/nita_online_payment_steps/4-7060d1aac29999dd31f0f6982f1474bc.png";